/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesBracketStatusSchema } from "./bracketStatusSchema.ts";
import { goodLuckCoreEntitiesBracketTypeSchema } from "./bracketTypeSchema.ts";
import { goodLuckCoreEntitiesMatchSchema } from "./matchSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesBracketSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  get type() {
    return goodLuckCoreEntitiesBracketTypeSchema.optional();
  },
  get status() {
    return goodLuckCoreEntitiesBracketStatusSchema.optional();
  },
  publishedAtUtc: z.iso.datetime().nullish(),
  publishedByUserId: z.string().nullish(),
  data: z.string().min(1),
  createdAt: z.optional(z.iso.datetime()),
  frozenAt: z.iso.datetime().nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get matches() {
    return z.array(goodLuckCoreEntitiesMatchSchema).nullish();
  },
});
